export { default } from './MrIcon';